import React, { useState, useContext, useEffect } from "react";
import { Form } from "react-bootstrap";
import {
  ManageTransactionLayout,
  LoaderWrapper,
  RejectRequestModal,
} from "../../../components";
import { useRouterParams, useDeepEffect, useRequest } from "../../../abstracts";
import { Formik } from "formik";
import { get } from "lodash";
import {
  FLOW_TYPES,
  usDateFormat,
  getAdvancedPathWithParam,
  MANAGE_CENSUS_ROUTES,
  toOptionValuesFromMapper,
  OPTIONS_DATA_MAPPER,
  MANAGE_TRANSACTION_ROUTES,
  getPathWithParam,
} from "../../../utils";
import {
  setRollOverRequestToastInfo,
  manageCensusStore,
  setManageTransactionToastInfo,
  manageTransactionStore,
} from "../../../contexts";
import {
  getRolloverInRequestDetailsById,
  saveRolloverInRequest,
  approveOrRejectRolloverInRequest,
  getEmployeeCensusInformation,
} from "../../../services";

const RollOverRequestsPendingApprovalConainer = (props, { onClickOfCard }) => {
  const { state, dispatch } = useContext(manageCensusStore);
  const { state: state2, dispatch: dispatch2 } = useContext(
    manageTransactionStore
  );
  const [pageData, setPageData] = useState({});
  const [amount, setAmount] = useState();
  const { censusId, summaryId } = useRouterParams();
  const { history } = props;
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [val, setVal] = useState(0);
  const [empName, setEmpName] = useState(null);
  const paymentOptions = {
    1: "Cheque",
    2: "EFT",
  };
  const accountTypeOptions = {
    1: "Saving Account",
    2: "Checking Account",
  };

  useEffect(() => {
    setLoading(true);
    getRolloverInRequestDetailsById(parseInt(summaryId, 10))
      .then((response) => {
        getEmployeeCensusInformation(response.employeeId).then((res) =>
          setEmpName(res.firstName + " " + res.middleName + " " + res.lastName)
        );
        setAmount(response?.rolloverAmount);
        if (response.isInvestmentAllocationsSameToAllSources)
          response.sourceLevelInvestments = [
            response.sourceLevelInvestments[0],
          ];
        setPageData(response);
        setLoading(false);
      })
      .catch((ex) => {
        setLoading(false);
      });
  }, []);

  const onApproveClick = () => {
    setShow(false);
    dispatch2(
      setManageTransactionToastInfo({
        showToast: true,
        toastMessage: "Rolloverin request is approved successfully",
        toastMessage2: empName,
        toastMessage1: "Rolloverin amount" + " " + amount,
        // reject: true,
      })
    );

    history.push(
      getPathWithParam({
        path: `${MANAGE_TRANSACTION_ROUTES.PENDINGROLLOVERIN}`,
      })
    );
  };

  const buttons = [
    {
      label: "Cancel",
      variant: "secondary",
      type: "button",
      onClick: () =>
        history.push(
          getAdvancedPathWithParam({
            path: MANAGE_TRANSACTION_ROUTES.PENDINGROLLOVERIN,
          })
        ),
    },
    {
      label: "Edit",
      variant: "secondary",
      type: "button",
      onClick: () =>
        history.push(
          getAdvancedPathWithParam({
            path: MANAGE_CENSUS_ROUTES.ROLLOVER_REQUEST,
            pathParam: [FLOW_TYPES.EDIT, censusId, summaryId, 1],
          })
        ),
    },
    {
      label: "Reject",
      variant: "outline-danger",
      type: "button",
      onClick: () => {
        // ApproveOrRejectRollOverIn(false, "")
        setShow(true);
      },
    },
    {
      label: "Approve",
      variant: "primary",
      type: "button",
      onClick: () => {
        ApproveOrRejectRollOverIn(true, "", () => {});
        onApproveClick();
      },
    },
  ];

  const RejectApiForRollOver = (isApproved, reasonForRejection, callBack) => {
    //setLoading(true);
    approveOrRejectRolloverInRequest({
      approval: isApproved,
      reasonForRejection: reasonForRejection,
      id: parseInt(summaryId, 10),
    })
      .then((response) => {
        //setLoading(false);
        callBack();
      })
      .catch((ex) => {});
  };

  const ApproveOrRejectRollOverIn = (
    isApproved,
    reasonForRejection,
    callBack
  ) => {
    setLoading(true);
    approveOrRejectRolloverInRequest({
      approval: isApproved,
      reasonForRejection: reasonForRejection,
      id: parseInt(summaryId, 10),
    })
      .then((response) => {
        setLoading(false);
        callBack();
        // dispatch(
        //     setManageTransactionToastInfo({
        //       showToast: true,
        //       toastMessage: isApproved?"Withdrawal request is approved successfully":"Withdrawal request is rejected",
        //       toastMessage1: "Employee Name|Reason ",
        //       reject: true,
        //     })
        //   )
        history.push(
          getAdvancedPathWithParam({
            path: MANAGE_TRANSACTION_ROUTES.PENDINGROLLOVERIN,
          })
        );
      })
      .catch((ex) => {
        setLoading(false);
      });
  };
  const customBreadCrumbs = [
    {
      label: "Withdrawls Approval",
      link: MANAGE_TRANSACTION_ROUTES.PENDINGROLLOVERIN,
    },
  ];
  const handleTotalForSources = (sourceInd) => {
    let sum = 0;
    if (pageData.rollOverSourceLevelContributions?.length > 0) {
      let x = pageData.rollOverSourceLevelContributions[sourceInd];
      sum = ["", NaN, undefined, null].includes(x.contributionAmount)
        ? sum + 0
        : sum + x.contributionAmount;
      sum = ["", NaN, undefined, null].includes(x.earnings)
        ? sum + 0
        : sum + x.earnings;
    }
    return sum;
  };
  const handleTotalForAllSources = () => {
    let sum = 0;
    if (pageData.rollOverSourceLevelContributions?.length > 0)
      pageData.rollOverSourceLevelContributions.forEach((x) => {
        sum = ["", NaN, undefined, null].includes(x.contributionAmount)
          ? sum + 0
          : sum + x.contributionAmount;
        sum = ["", NaN, undefined, null].includes(x.earnings)
          ? sum + 0
          : sum + x.earnings;
      });
    return sum;
  };
  const handleTotal = (sourceInd) => {
    let sum = 0;
    if (pageData.sourceLevelInvestments?.length > 0)
      pageData.sourceLevelInvestments[sourceInd].forEach(
        (x) =>
          (sum = ["", NaN, undefined, null].includes(x.investmentPercentage)
            ? sum + 0
            : sum + x.investmentPercentage)
      );
    return sum;
  };
  useDeepEffect(
    () => {
      ApproveOrRejectRollOverIn(false, val.reasonForRejection);
    },
    [val],
    true
  );

  return (
    <LoaderWrapper isLoading={loading}>
      <ManageTransactionLayout
        buttons={buttons}
        layoutHeader="New Rollover Request"
        customBreadCrumbs={customBreadCrumbs}
      >
        <div style={{ overflow: "auto", height: "80vh" }}>
          <p className="plancard-header">Plan Details</p>
          <div className="summary-plan-card">
            <div className="plancard-firstblock">
              <p className="summary-planname">
                {pageData.planDetails?.name}
                {/* Fidelity's self-employed 401(k) Plan */}
              </p>
              <p className="summary-font" style={{ margin: "0px" }}>
                {pageData?.planDetails?.planId}
                {/* 12345 */}
              </p>
            </div>
            <div className="plancard-secondblock">
              <p className="summary-font  mb-3">Type</p>
              <p className="summary-font2">{pageData.planDetails?.planType}</p>
            </div>
            <div className="plancard-lastblock">
              <p className="summary-font  mb-3">Available source(s)</p>
              <p className="summary-font2">{pageData?.planDetails?.sources}</p>
            </div>
          </div>

          <div className="plan-details-container">
            <p className="plan-details-header">Distributing Plan Details</p>
            <div className="line-separator" />
            <p className="plan-details-header">
              Previous Plan and Company Details
            </p>
            <div className="mb-20">
              <p className="field-header">Plan name</p>
              <p className="ft-16 ftwt-500 light-grey">
                {" "}
                {pageData?.previousEmploymentDetails?.planName}
              </p>
            </div>
            <div className="mb-20">
              <p className="field-header">Plan type</p>
              <p className="ft-16 ftwt-500 light-grey">
                {pageData?.previousEmploymentDetails?.planType &&
                  OPTIONS_DATA_MAPPER.PLAN_TYPES[
                    pageData?.previousEmploymentDetails?.planType
                  ]}
              </p>
            </div>
            <div className="mb-20">
              <p className="field-header">Company name</p>
              <p className="ft-16 ftwt-500 light-grey">
                {pageData?.previousEmploymentDetails?.companyName}
              </p>
            </div>
            <p className="plan-details-header mt-50">
              Previous Trustee / Custodian Details
            </p>
            <div>
              <p className="field-header">Trustee / Custodian name</p>
              <p className="ft-16 ftwt-500 light-grey">
                {pageData?.previousEmploymentDetails?.trusteeOrCustodianName}
              </p>
            </div>
            <div>
              <p className="field-header">Bank name</p>
              <p className="ft-16 ftwt-500 light-grey">
                {pageData?.previousEmploymentDetails?.custodianBankName}
              </p>
            </div>
            <div>
              <p className="field-header">Custodial account number</p>
              <p className="ft-16 ftwt-500 light-grey">
                {pageData?.previousEmploymentDetails?.custodianAccountNumber}
              </p>
            </div>
            <p className="plan-details-header mt-50">Rollover Amount</p>
            <div>
              <p className="field-header">Enter rollover amount</p>
              <p className="ft-16 ftwt-500 light-grey">
                {pageData?.rolloverAmount}
              </p>
            </div>

            <div className="sourcemapping-table">
              <ul style={{ listStyle: "none", paddingRight: "20px" }}>
                <li>
                  <div className="row border-bottom mb-30">
                    <p className="ft-16 ftwt-500 dark-grey">Source Mapping</p>
                    <p className="ft-16 ftwt-500 dark-grey">Contributions</p>
                    <p className="ft-16 ftwt-500 dark-grey">Earnings</p>

                    <p className="ft-16 ftwt-500 dark-grey">Total</p>
                  </div>
                </li>
                {pageData?.rollOverSourceLevelContributions?.map(
                  (data, index) => {
                    return (
                      <li>
                        <div className="row border-bottom mb-30">
                          <p className="col-2 ft-16 dark-grey">
                            {data.sourceName}
                          </p>
                          <p>
                            $
                            {data.contributionAmount
                              ? data.contributionAmount
                              : 0}
                          </p>
                          <p>${data.earnings ? data.earnings : 0}</p>
                          <p className="ft-16 dark-grey">
                            {handleTotalForSources(index)}
                          </p>
                        </div>
                      </li>
                    );
                  }
                )}
                <li>
                  <div className="w-90 row justifyContent mt-25">
                    <p className="col-4 bold ft-16 dark-grey">
                      Total rollover amount
                    </p>
                    <p className="bold ft-16 dark-grey">
                      {handleTotalForAllSources()}
                    </p>
                  </div>
                </li>
              </ul>
            </div>

            {pageData?.rothFirstContributionDate ? (
              <div>
                <p className="mt-50 field-header">
                  First contribution date for Roth
                </p>
                <p className="ft-16 ftwt-500 light-grey">
                  {usDateFormat(pageData?.rothFirstContributionDate)}
                </p>
              </div>
            ) : (
              <></>
            )}
            <p className=" mt-50 plan-details-header">Transaction details</p>
            <div className="mb-20">
              <p className="field-header">Payment mode</p>
              <p className="ft-16 ftwt-500 light-grey">
                {pageData?.rollOverTransactionInfo?.paymentMode &&
                  paymentOptions[
                    pageData?.rollOverTransactionInfo?.paymentMode
                  ]}
              </p>
            </div>
            {pageData?.rollOverTransactionInfo?.paymentMode === 1 ? (
              <div>
                <div className="mb-20">
                  <p className="field-header">Bank Name</p>
                  <p className="ft-16 ftwt-500 light-grey">
                    {
                      pageData?.rollOverTransactionInfo
                        ?.financialInstitutionName
                    }
                  </p>
                </div>

                <div className="mb-20">
                  <p className="field-header">Cheque number</p>
                  <p className="ft-16 ftwt-500 light-grey">
                    {pageData?.rollOverTransactionInfo.chequeNumber}
                  </p>
                </div>

                <div className="mb-20">
                  <p className="field-header">Routing Number</p>
                  <p className="ft-16 ftwt-500 light-grey">
                    {pageData?.rollOverTransactionInfo?.routingNumber}
                  </p>
                </div>
              </div>
            ) : null}

            {pageData?.rollOverTransactionInfo?.paymentMode === 2 ? (
              <div>
                <div className="mb-20">
                  <p className="field-header">
                    Name of the financial Institution
                  </p>
                  <p className="ft-16 ftwt-500 light-grey">
                    {
                      pageData?.rollOverTransactionInfo
                        ?.financialInstitutionName
                    }
                  </p>
                </div>

                <div className="mb-20">
                  <p className="field-header">Account Holder Name</p>
                  <p className="ft-16 ftwt-500 light-grey">
                    {pageData?.rollOverTransactionInfo?.accountHolderName}
                  </p>
                </div>

                <div className="mb-20">
                  <p className="field-header">Account Type</p>
                  <p className="ft-16 ftwt-500 light-grey">
                    {
                      accountTypeOptions[
                        pageData?.rollOverTransactionInfo?.accountType
                      ]
                    }
                  </p>
                </div>

                <div className="mb-20">
                  <p className="field-header">Account Number</p>
                  <p className="ft-16 ftwt-500 light-grey">
                    {pageData?.rollOverTransactionInfo?.accountNumber}
                  </p>
                </div>

                <div className="mb-20">
                  <p className="field-header">
                    Routing Number of Bank or Credit Union
                  </p>
                  <p className="ft-16 ftwt-500 light-grey">
                    {pageData?.rollOverTransactionInfo?.routingNumber}
                  </p>
                </div>
              </div>
            ) : null}

            <p className="ft-16 ftwt-500 dark-grey mt-50">Uploaded Documents</p>
            <div className="summary-uploaddoc">
              <div className="row" style={{ marginTop: "8px" }}>
                {pageData?.documentDetails?.length > 0 ? (
                  pageData?.documentDetails?.map((x) => {
                    return (
                      <>
                        <div
                          className="col-5"
                          style={{
                            height: "20px",
                            maxWidth: "375px",
                            borderRight: "2px solid #c0b8b8",
                          }}
                        >
                          <i
                            className="fas fa-file-word"
                            style={{ color: "blue", fontSize: "25px" }}
                          ></i>{" "}
                          &nbsp;
                          <a href={x.path} target="_blank">
                            {x.fileName}
                          </a>
                        </div>
                        {/* <div className="col-1" style={{ marginRight: "30px" }}>
                      <p style={{ fontSize: "15px", color: "#aca1a1" }}>5.7MB</p>
                    </div> */}
                      </>
                    );
                  })
                ) : (
                  <p>No documents uploaded</p>
                )}
              </div>
            </div>
          </div>

          {pageData?.sourceLevelInvestments?.length > 0 &&
            pageData.sourceLevelInvestments.map((data, ind) => {
              return (
                <div>
                  <p className="dark-grey ft-18 ftwt-500 mt-40">
                    {pageData.isInvestmentAllocationsSameToAllSources
                      ? "Investment Mapping"
                      : `Investment Mapping By Source - ${data[0].sourceName}`}
                  </p>

                  <div className="w-90 sourcemapping-container">
                    <ul style={{ listStyle: "none", paddingRight: "20px" }}>
                      <li>
                        <div className="row border-bottom mb-20">
                          <p className="dark-grey ft-16 ftwt-500">
                            Investment name
                          </p>
                          <p className="dark-grey ft-16 ftwt-500">Percentage</p>
                        </div>
                      </li>
                      {data.map((item, index) => {
                        const fieldName = `sourceLevelInvestments.${ind}.${index}.investmentPercentage`;
                        return (
                          <li>
                            <div
                              className="d-flex justifyContent border-bottom mb-20"
                              style={{ marginRight: "25px" }}
                            >
                              <p className="dark-grey ft-16">
                                {item.investmentName}
                              </p>
                              <p className="dark-grey ft-16 ftwt-500">
                                {item.investmentPercentage}%
                              </p>
                            </div>
                          </li>
                        );
                      })}

                      <li>
                        <div
                          className="w-100 d-flex justifyContent mt-25"
                          style={{ marginRight: "25px" }}
                        >
                          <p className="bold dark-grey ft-16">
                            Total Percentage
                          </p>
                          <p className="bold dark-grey ft-16">
                            {handleTotal(ind)}%
                          </p>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              );
            })}
        </div>
      </ManageTransactionLayout>
      <RejectRequestModal
        show={show}
        setShow={setShow}
        setVal={setVal}
        history={history}
        amount={amount}
        ApproveOrRejectRollOverIn={ApproveOrRejectRollOverIn}
        empName={empName}
      />
    </LoaderWrapper>
  );
};
export default RollOverRequestsPendingApprovalConainer;
